exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox-wrapper[data-v-be6b518c] {\n  position: relative;\n}\n.checkbox-wrapper[data-v-be6b518c]::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: #FFF;\n  opacity: 0;\n  visibility: hidden;\n  transition-property: opacity, visibility;\n  transition-duration: 250ms;\n  transition-delay: 0ms, 250ms;\n}\n.checkbox-wrapper.is-disabled[data-v-be6b518c]:after {\n  visibility: visible;\n  opacity: 0.6;\n  transition-delay: 0ms, 0ms;\n}", ""]);

// exports
